module.exports = __webpack_public_path__ + "img/FC3D.png";